var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/engines/index.ts
var engines_exports = {};
__export(engines_exports, {
  local: () => local_exports
});

// src/engines/local/index.ts
var local_exports = {};
__export(local_exports, {
  filterPersonList: () => filterPersonList,
  filterProjectList: () => filterProjectList
});

// src/filters/index.ts
var filters_exports = {};
__export(filters_exports, {
  and: () => and,
  asTypeList: () => asTypeList,
  find: () => find,
  findPath: () => findPath,
  flat: () => flat,
  flatMap: () => flatMap,
  isDatePayload: () => isDatePayload,
  isEqual: () => isEqual,
  isFilter: () => isFilter,
  isFilterList: () => isFilterList,
  length: () => length,
  migrateLegacySkillIdList: () => migrateLegacySkillIdList,
  or: () => or,
  personCustomCheckbox: () => personCustomCheckbox,
  personCustomDate: () => personCustomDate,
  personCustomDateValue: () => personCustomDateValue,
  personCustomSelect: () => personCustomSelect,
  personCustomText: () => personCustomText,
  personCustomTextValue: () => personCustomTextValue,
  personEmail: () => personEmail,
  personEmploymentType: () => personEmploymentType,
  personId: () => personId,
  personIsActive: () => personIsActive,
  personIsFavourite: () => personIsFavourite,
  personIsPlaceholder: () => personIsPlaceholder,
  personJobTitleName: () => personJobTitleName,
  personManagerId: () => personManagerId,
  personMembership: () => personMembership,
  personName: () => personName,
  personPlaceholderStatus: () => personPlaceholderStatus,
  personProjectClientId: () => personProjectClientId,
  personProjectClientName: () => personProjectClientName,
  personProjectCustomCheckbox: () => personProjectCustomCheckbox,
  personProjectCustomDate: () => personProjectCustomDate,
  personProjectCustomDateValue: () => personProjectCustomDateValue,
  personProjectCustomSelect: () => personProjectCustomSelect,
  personProjectCustomText: () => personProjectCustomText,
  personProjectCustomTextValue: () => personProjectCustomTextValue,
  personProjectId: () => personProjectId,
  personProjectIsConfirmed: () => personProjectIsConfirmed,
  personProjectManagerId: () => personProjectManagerId,
  personProjectName: () => personProjectName,
  personProjectRoleId: () => personProjectRoleId,
  personProjectStatus: () => personProjectStatus,
  personProjectTagId: () => personProjectTagId,
  personProjectTeamId: () => personProjectTeamId,
  personProjectTemplateId: () => personProjectTemplateId,
  personProjectWorkstreamId: () => personProjectWorkstreamId,
  personRoleId: () => personRoleId,
  personRoleName: () => personRoleName,
  personSkillId: () => personSkillId,
  personSkillName: () => personSkillName,
  personState: () => personState,
  personTagId: () => personTagId,
  personTagName: () => personTagName,
  personTeamId: () => personTeamId,
  personTeamName: () => personTeamName,
  personType: () => personType,
  personWildSearch: () => personWildSearch,
  projectClientId: () => projectClientId,
  projectClientName: () => projectClientName,
  projectCustomCheckbox: () => projectCustomCheckbox,
  projectCustomDate: () => projectCustomDate,
  projectCustomDateValue: () => projectCustomDateValue,
  projectCustomSelect: () => projectCustomSelect,
  projectCustomText: () => projectCustomText,
  projectCustomTextValue: () => projectCustomTextValue,
  projectId: () => projectId,
  projectIsActive: () => projectIsActive,
  projectIsConfirmed: () => projectIsConfirmed,
  projectIsFavourite: () => projectIsFavourite,
  projectIsTemplate: () => projectIsTemplate,
  projectManagerId: () => projectManagerId,
  projectName: () => projectName,
  projectPersonCustomCheckbox: () => projectPersonCustomCheckbox,
  projectPersonCustomDate: () => projectPersonCustomDate,
  projectPersonCustomDateValue: () => projectPersonCustomDateValue,
  projectPersonCustomSelect: () => projectPersonCustomSelect,
  projectPersonCustomText: () => projectPersonCustomText,
  projectPersonCustomTextValue: () => projectPersonCustomTextValue,
  projectPersonEmail: () => projectPersonEmail,
  projectPersonId: () => projectPersonId,
  projectPersonJobTitleName: () => projectPersonJobTitleName,
  projectPersonManagerId: () => projectPersonManagerId,
  projectPersonName: () => projectPersonName,
  projectPersonPlaceholderStatus: () => projectPersonPlaceholderStatus,
  projectPersonRoleId: () => projectPersonRoleId,
  projectPersonSkillId: () => projectPersonSkillId,
  projectPersonTagId: () => projectPersonTagId,
  projectPersonTeamId: () => projectPersonTeamId,
  projectPricingModel: () => projectPricingModel,
  projectState: () => projectState,
  projectStatus: () => projectStatus,
  projectTagId: () => projectTagId,
  projectTagName: () => projectTagName,
  projectTeamId: () => projectTeamId,
  projectTeamName: () => projectTeamName,
  projectTemplateId: () => projectTemplateId,
  projectWildSearch: () => projectWildSearch,
  projectWorkstreamId: () => projectWorkstreamId,
  replace: () => replace,
  simplify: () => simplify,
  some: () => some
});

// src/filters/logic.ts
var or = (items) => {
  return {
    logic: "or",
    items: items.filter(Boolean)
  };
};
var and = (items) => {
  return {
    logic: "and",
    items: items.filter(Boolean)
  };
};

// src/filters/person-custom-select.ts
var personCustomSelect = (options) => ({
  type: "person_custom_select",
  options
});

// src/filters/person-custom-text.ts
var personCustomText = (options) => ({
  type: "person_custom_text",
  options
});

// src/filters/person-custom-text-value.ts
var personCustomTextValue = (options) => ({
  type: "person_custom_text_value",
  options
});

// src/filters/person-custom-date.ts
var personCustomDate = (options) => ({
  type: "person_custom_date",
  options
});

// src/filters/person-custom-date-value.ts
var personCustomDateValue = (options) => ({
  type: "person_custom_date_value",
  options
});

// src/filters/person-email.ts
var personEmail = (options) => ({
  type: "person_email",
  options
});

// src/filters/person-employment-type.ts
var personEmploymentType = (options) => ({
  type: "person_employment_type",
  options
});

// src/filters/person-type.ts
var personType = (options) => ({
  type: "person_type",
  options
});

// src/filters/person-id.ts
var personId = (options) => ({
  type: "person_id",
  options
});

// src/filters/person-is-active.ts
var personIsActive = (options) => ({
  type: "person_is_active",
  options
});

// src/filters/person-is-favourite.ts
var personIsFavourite = (options) => ({
  type: "person_is_favourite",
  options
});

// src/filters/person-is-placeholder.ts
var personIsPlaceholder = (options) => ({
  type: "person_is_placeholder",
  options
});

// src/filters/person-name.ts
var personName = (options) => ({
  type: "person_name",
  options
});

// src/filters/person-project-client-name.ts
var personProjectClientName = (options) => ({
  type: "person_project_client_name",
  options
});

// src/filters/person-project-id.ts
var personProjectId = (options) => ({
  type: "person_project_id",
  options
});

// src/filters/person-membership.ts
var personMembership = (options) => ({
  type: "person_membership",
  options
});

// src/filters/person-project-template-id.ts
var personProjectTemplateId = (options) => ({
  type: "person_project_template_id",
  options
});

// src/filters/person-project-is-confirmed.ts
var personProjectIsConfirmed = (options) => ({
  type: "person_project_is_confirmed",
  options
});

// src/filters/person-project-name.ts
var personProjectName = (options) => ({
  type: "person_project_name",
  options
});

// src/filters/person-project-status.ts
var personProjectStatus = (options) => ({
  type: "person_project_status",
  options
});

// src/filters/person-project-custom-select.ts
var personProjectCustomSelect = (options) => ({
  type: "person_project_custom_select",
  options
});

// src/filters/person-project-custom-text.ts
var personProjectCustomText = (options) => ({
  type: "person_project_custom_text",
  options
});

// src/filters/person-project-custom-text-value.ts
var personProjectCustomTextValue = (options) => ({
  type: "person_project_custom_text_value",
  options
});

// src/filters/person-project-custom-date.ts
var personProjectCustomDate = (options) => ({
  type: "person_project_custom_date",
  options
});

// src/filters/person-project-custom-date-value.ts
var personProjectCustomDateValue = (options) => ({
  type: "person_project_custom_date_value",
  options
});

// src/filters/person-job-title-name.ts
var personJobTitleName = (options) => ({
  type: "person_job_title_name",
  options
});

// src/filters/person-role-id.ts
var personRoleId = (options) => ({
  type: "person_role_id",
  options
});

// src/filters/person-role-name.ts
var personRoleName = (options) => ({
  type: "person_role_name",
  options
});

// src/filters/person-skill-id.ts
var personSkillId = (options) => ({
  type: "person_skill_id",
  options
});
var isLegacySkillIdList = (list) => {
  return typeof list[0] === "number";
};
var migrateLegacySkillIdList = (list) => {
  if (isLegacySkillIdList(list)) {
    return list.map((skillId) => ({
      skillId,
      level: [null, 1, 2, 3, 4]
      // all skill levels
    }));
  }
  return list;
};

// src/filters/person-skill-name.ts
var personSkillName = (options) => ({
  type: "person_skill_name",
  options
});

// src/filters/person-state.ts
var personState = (options) => ({
  type: "person_state",
  options
});

// src/filters/person-tag-id.ts
var personTagId = (options) => ({
  type: "person_tag_id",
  options
});

// src/filters/person-tag-name.ts
var personTagName = (options) => ({
  type: "person_tag_name",
  options
});

// src/filters/person-team-id.ts
var personTeamId = (options) => ({
  type: "person_team_id",
  options
});

// src/filters/person-team-name.ts
var personTeamName = (options) => ({
  type: "person_team_name",
  options
});

// src/filters/person-wild-search.ts
var personWildSearch = (options) => ({
  type: "person_wild_search",
  options
});

// src/filters/person-placeholder-status.ts
var personPlaceholderStatus = (options) => ({
  type: "person_placeholder_status",
  options
});

// src/filters/project-client-id.ts
var projectClientId = (options) => ({
  type: "project_client_id",
  options
});

// src/filters/project-client-name.ts
var projectClientName = (options) => ({
  type: "project_client_name",
  options
});

// src/filters/project-custom-select.ts
var projectCustomSelect = (options) => ({
  type: "project_custom_select",
  options
});

// src/filters/project-custom-text.ts
var projectCustomText = (options) => ({
  type: "project_custom_text",
  options
});

// src/filters/project-custom-text-value.ts
var projectCustomTextValue = (options) => ({
  type: "project_custom_text_value",
  options
});

// src/filters/project-custom-date.ts
var projectCustomDate = (options) => ({
  type: "project_custom_date",
  options
});

// src/filters/project-custom-date-value.ts
var projectCustomDateValue = (options) => ({
  type: "project_custom_date_value",
  options
});

// src/filters/project-id.ts
var projectId = (options) => ({
  type: "project_id",
  options
});

// src/filters/project-template-id.ts
var projectTemplateId = (options) => ({
  type: "project_template_id",
  options
});

// src/filters/project-is-active.ts
var projectIsActive = (options) => ({
  type: "project_is_active",
  options
});

// src/filters/project-is-confirmed.ts
var projectIsConfirmed = (options) => ({
  type: "project_is_confirmed",
  options
});

// src/filters/project-is-favourite.ts
var projectIsFavourite = (options) => ({
  type: "project_is_favourite",
  options
});

// src/filters/project-is-template.ts
var projectIsTemplate = (options) => ({
  type: "project_is_template",
  options
});

// src/filters/project-name.ts
var projectName = (options) => ({
  type: "project_name",
  options
});

// src/filters/project-person-email.ts
var projectPersonEmail = (options) => ({
  type: "project_person_email",
  options
});

// src/filters/project-person-id.ts
var projectPersonId = (options) => ({
  type: "project_person_id",
  options
});

// src/filters/project-person-name.ts
var projectPersonName = (options) => ({
  type: "project_person_name",
  options
});

// src/filters/project-person-team-id.ts
var projectPersonTeamId = (options) => ({
  type: "project_person_team_id",
  options
});

// src/filters/project-person-placeholder-status.ts
var projectPersonPlaceholderStatus = (options) => ({
  type: "project_person_placeholder_status",
  options
});

// src/filters/project-person-custom-select.ts
var projectPersonCustomSelect = (options) => ({
  type: "project_person_custom_select",
  options
});

// src/filters/project-person-custom-text.ts
var projectPersonCustomText = (options) => ({
  type: "project_person_custom_text",
  options
});

// src/filters/project-person-custom-text-value.ts
var projectPersonCustomTextValue = (options) => ({
  type: "project_person_custom_text_value",
  options
});

// src/filters/project-person-custom-date.ts
var projectPersonCustomDate = (options) => ({
  type: "project_person_custom_date",
  options
});

// src/filters/project-person-custom-date-value.ts
var projectPersonCustomDateValue = (options) => ({
  type: "project_person_custom_date_value",
  options
});

// src/filters/project-state.ts
var projectState = (options) => ({
  type: "project_state",
  options
});

// src/filters/project-status.ts
var projectStatus = (options) => ({
  type: "project_status",
  options
});

// src/filters/project-tag-id.ts
var projectTagId = (options) => ({
  type: "project_tag_id",
  options
});

// src/filters/project-tag-name.ts
var projectTagName = (options) => ({
  type: "project_tag_name",
  options
});

// src/filters/project-team-id.ts
var projectTeamId = (options) => ({
  type: "project_team_id",
  options
});

// src/filters/project-team-name.ts
var projectTeamName = (options) => ({
  type: "project_team_name",
  options
});

// src/filters/project-wild-search.ts
var projectWildSearch = (options) => ({
  type: "project_wild_search",
  options
});

// src/filters/project-pricing-model.ts
var projectPricingModel = (options) => ({
  type: "project_pricing_model",
  options
});

// src/filters/utils.ts
import { isEqual as compareEqual } from "lodash-es";
var hasProperty = (obj, prop) => {
  return prop in obj;
};
var isFilterList = (item) => {
  return item !== null && item !== void 0 && hasProperty(item, "logic") && typeof item.logic === "string" && hasProperty(item, "items") && Array.isArray(item.items);
};
var isFilter = (item) => {
  return item !== null && item !== void 0 && hasProperty(item, "type") && typeof item.type === "string" && hasProperty(item, "options") && typeof item.options === "object" && item.options !== null;
};
var simplify = (parent) => {
  if (!isFilterList(parent)) {
    return parent;
  }
  const parentLogic = parent.items.length < 2 ? "and" : parent.logic;
  const items = parent.items.flatMap((rawChild) => {
    if (isFilterList(rawChild)) {
      const child = simplify(rawChild);
      if (isFilterList(child) && parentLogic === child.logic) {
        return child.items;
      }
      return child;
    } else {
      return rawChild;
    }
  });
  if (items.length === 1) {
    return items[0];
  }
  return {
    logic: parentLogic,
    items
  };
};
var isEqual = (a, b) => {
  if (a === b || !a && !b) {
    return true;
  }
  if (isFilter(a) && isFilter(b)) {
    return a.type === b.type && compareEqual(a.options, b.options);
  }
  if (isFilterList(a) && isFilterList(b)) {
    return a.logic === b.logic && a.items.length === b.items.length && a.items.every((aItem, index) => {
      const bItem = b.items[index];
      return isEqual(aItem, bItem);
    });
  }
  return false;
};
var some = (filter, predicate) => {
  if (isFilterList(filter)) {
    for (const item of filter.items) {
      if (isFilterList(item)) {
        const result = some(item, predicate);
        if (result === true) {
          return true;
        }
      } else {
        if (predicate(item)) {
          return true;
        }
      }
    }
  } else if (filter && predicate(filter)) {
    return true;
  }
  return false;
};
var find = (filter, predicate) => {
  if (isFilterList(filter)) {
    for (const item of filter.items) {
      if (isFilterList(item)) {
        const result = find(item, predicate);
        if (typeof result !== "undefined") {
          return result;
        }
      } else {
        if (predicate(item)) {
          return item;
        }
      }
    }
  } else if (filter && predicate(filter)) {
    return filter;
  }
  return void 0;
};
var findPath = (filter, predicate, path = []) => {
  if (isFilterList(filter)) {
    for (const [index, item] of filter.items.entries()) {
      if (isFilterList(item)) {
        const result = findPath(item, predicate, [...path, index]);
        if (typeof result !== "undefined") {
          return result;
        }
      } else {
        if (predicate(item)) {
          return [...path, index];
        }
      }
    }
  } else if (filter && predicate(filter)) {
    return path;
  }
  return void 0;
};
var flatMap = (filter, transform, path = []) => {
  const output = [];
  if (isFilterList(filter)) {
    output.push(
      ...filter.items.flatMap((item, index) => {
        if (isFilterList(item)) {
          return flatMap(item, transform, [...path, index]);
        } else {
          return transform(item, [...path, index]);
        }
      })
    );
  } else if (filter) {
    output.push(transform(filter, path));
  }
  return output;
};
var replace = (filterList2, path, fn) => {
  if (path.length === 0) {
    return fn(filterList2);
  }
  const [head, ...tail] = path;
  if (typeof head === "number" && isFilterList(filterList2)) {
    const items = filterList2.items.slice(0);
    const child = items[head];
    if (child) {
      const result = replace(child, tail, fn);
      if (typeof result === "undefined") {
        items.splice(head, 1);
      } else {
        items[head] = result;
      }
      return { ...filterList2, items };
    }
  }
  throw new Error(JSON.stringify({ head, filterList: filterList2 }));
};
var asTypeList = (filterList2) => {
  const set = new Set(flatMap(filterList2, (filter) => filter.type));
  return [...set];
};
var flat = (filterList2) => {
  return flatMap(filterList2, (filter) => filter);
};
var length = (filterList2) => {
  return flat(filterList2).length;
};
var isDatePayload = (payload) => {
  if (payload === null || typeof payload !== "object") {
    return false;
  }
  if ("type" in payload && typeof payload.type === "string") {
    return payload.type === "range" || payload.type === "exact";
  }
  return false;
};

// src/filters/person-project-team-id.ts
var personProjectTeamId = (options) => ({
  type: "person_project_team_id",
  options
});

// src/filters/project-person-skill-id.ts
var projectPersonSkillId = (options) => ({
  type: "project_person_skill_id",
  options
});

// src/filters/project-person-tag-id.ts
var projectPersonTagId = (options) => ({
  type: "project_person_tag_id",
  options
});

// src/filters/person-project-client-id.ts
var personProjectClientId = (options) => ({
  type: "person_project_client_id",
  options
});

// src/filters/person-project-tag-id.ts
var personProjectTagId = (options) => ({
  type: "person_project_tag_id",
  options
});

// src/filters/person-project-workstream-id.ts
var personProjectWorkstreamId = (options) => ({
  type: "person_project_workstream_id",
  options
});

// src/filters/project-workstream-id.ts
var projectWorkstreamId = (options) => ({
  type: "project_workstream_id",
  options
});

// src/filters/project-person-role-id.ts
var projectPersonRoleId = (options) => ({
  type: "project_person_role_id",
  options
});

// src/filters/person-project-role-id.ts
var personProjectRoleId = (options) => ({
  type: "person_project_role_id",
  options
});

// src/filters/person-custom-checkbox.ts
var personCustomCheckbox = (options) => ({
  type: "person_custom_checkbox",
  options
});

// src/filters/project-custom-checkbox.ts
var projectCustomCheckbox = (options) => ({
  type: "project_custom_checkbox",
  options
});

// src/filters/person-project-custom-checkbox.ts
var personProjectCustomCheckbox = (options) => ({
  type: "person_project_custom_checkbox",
  options
});

// src/filters/project-person-custom-checkbox.ts
var projectPersonCustomCheckbox = (options) => ({
  type: "project_person_custom_checkbox",
  options
});

// src/filters/project-person-job-title-name.ts
var projectPersonJobTitleName = (options) => ({
  type: "project_person_job_title_name",
  options
});

// src/filters/project-manager-id.ts
var projectManagerId = (options) => ({
  type: "project_manager_id",
  options
});

// src/filters/person-manager-id.ts
var personManagerId = (options) => ({
  type: "person_manager_id",
  options
});

// src/filters/project-person-manager-id.ts
var projectPersonManagerId = (options) => ({
  type: "project_person_manager_id",
  options
});

// src/filters/person-project-manager-id.ts
var personProjectManagerId = (options) => ({
  type: "person_project_manager_id",
  options
});

// src/engines/local/filter-fns/person-custom-checkbox.ts
var personCustomCheckbox2 = ({
  typeId,
  query
}) => {
  return ({ person }) => {
    if (!person || !person.custom_checkbox_values) {
      return false;
    }
    return person.custom_checkbox_values.filter((v) => v.custom_checkbox_type_id === typeId).some((c) => c.value === query);
  };
};

// src/engines/local/filter-fns/person-custom-date-value.ts
var personCustomDateValue2 = (datePayload) => {
  return ({ person }) => {
    if (!person || !person.custom_date_values) {
      return false;
    }
    if (datePayload.type === "exact") {
      if (!datePayload.exact) {
        return true;
      }
      const exact = new Date(datePayload.exact);
      return person.custom_date_values.some((c) => {
        const value = new Date(c.value);
        return value.toDateString() === exact.toDateString();
      });
    } else if (datePayload.type === "range") {
      if (!datePayload.start || !datePayload.end) {
        return true;
      }
      const start = new Date(datePayload.start);
      const end = new Date(datePayload.end);
      return person.custom_date_values.some((c) => {
        const value = new Date(c.value);
        return value >= start && value <= end;
      });
    }
    return false;
  };
};

// src/engines/local/filter-fns/person-custom-date.ts
var personCustomDate2 = ({
  typeId,
  datePayload
}) => {
  return ({ person }) => {
    if (!person || !person.custom_date_values) {
      return false;
    }
    if (datePayload.type === "exact") {
      if (!datePayload.exact) {
        return true;
      }
      const exact = new Date(datePayload.exact);
      return Boolean(
        person.custom_date_values.filter((v) => v.custom_date_type_id === typeId).find((c) => {
          const value = new Date(c.value);
          return value.toDateString() === exact.toDateString();
        })
      );
    } else if (datePayload.type === "range") {
      if (!datePayload.start || !datePayload.end) {
        return true;
      }
      const start = new Date(datePayload.start);
      const end = new Date(datePayload.end);
      return Boolean(
        person.custom_date_values.filter((v) => v.custom_date_type_id === typeId).find((c) => {
          const value = new Date(c.value);
          return value >= start && value <= end;
        })
      );
    }
    return false;
  };
};

// src/engines/local/filter-fns/person-custom-select.ts
var personCustomSelect2 = ({ list }, { person }) => {
  if (!person || !person.custom_select_values) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return person.custom_select_values.some(
    (v) => list.includes(v.custom_select_option_id)
  );
};

// src/engines/local/utils/escape-string-regexp.ts
var escapeStringRegexp = (value) => {
  if (typeof value !== "string") {
    console.error(`Expected a string but got: ${value} of type ${typeof value}`);
    return "";
  }
  return value.trim().replace(/\s+/g, " ").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
var escape_string_regexp_default = escapeStringRegexp;

// src/engines/local/utils/remove-accents-regexp.ts
var removeAccentsRegex = (value) => {
  if (typeof value !== "string") {
    console.error(`Expected a string but got: ${value} of type ${typeof value}`);
    return "";
  }
  return value.replace(/[àáâäǎæãåāa]/gi, "a").replace(/[èéêëěẽēėę]/gi, "e").replace(/[ìíîïǐĩīıį]/gi, "i").replace(/[òóôöǒœøõō]/gi, "o").replace(/[ùúûüǔũūűů]/gi, "u").replace(/[çćčċ]/gi, "c").replace(/[ďð]/gi, "d").replace(/[ğġ]/gi, "g").replace(/[ħ]/gi, "h").replace(/[ķ]/gi, "k").replace(/[łļľ]/gi, "l").replace(/[ñńņň]/gi, "n").replace(/[ř]/gi, "r").replace(/[ßşșśš]/gi, "s").replace(/[țťþ]/gi, "t").replace(/[ŵ]/gi, "w").replace(/[ýŷÿ]/gi, "y").replace(/[źžż]/gi, "z");
};
var remove_accents_regexp_default = removeAccentsRegex;

// src/engines/local/filter-fns/person-custom-text-value.ts
var personCustomTextValue2 = ({
  query
}) => {
  const regexp = new RegExp(
    `(?:^|\\W)${remove_accents_regexp_default(escape_string_regexp_default(query))}`,
    "i"
  );
  return ({ person }) => {
    if (!person || !person.custom_text_values) {
      return false;
    }
    return person.custom_text_values.some((c) => {
      return regexp.test(remove_accents_regexp_default(c.value));
    });
  };
};

// src/engines/local/filter-fns/person-custom-text.ts
var personCustomText2 = ({
  typeId,
  query,
  searchType
}) => {
  return ({ person }) => {
    if (!person || !person.custom_text_values) {
      return false;
    }
    const searchValues = query.trim().toLowerCase().split("|").map((v) => remove_accents_regexp_default(v.trim())).filter((v) => v);
    if (searchValues.length === 0) {
      return true;
    }
    return searchValues.some((searchValue) => {
      const regexp = new RegExp(
        `(?:^|\\W)${escape_string_regexp_default(searchValue)}`,
        "i"
      );
      return person.custom_text_values.filter((v) => v.custom_text_type_id === typeId).some((c) => {
        const value = remove_accents_regexp_default(c.value.toLowerCase());
        if (searchType === "exact") {
          return value === searchValue;
        }
        return regexp.test(value);
      });
    });
  };
};

// src/engines/local/filter-fns/person-email.ts
var personEmail2 = ({ query }) => {
  const regexp = new RegExp(`^${escape_string_regexp_default(query)}`, "i");
  return ({ person }) => {
    if (!person) {
      return false;
    }
    if (typeof person.email !== "string") {
      return false;
    }
    return regexp.test(person.email);
  };
};

// src/engines/local/filter-fns/person-employment-type.ts
var personEmploymentType2 = ({ list }, { person }, { timeRange }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  if (!person.contracts?.length) {
    return false;
  }
  if (!timeRange) {
    return person.contracts.some(
      (contract) => list.includes(contract.employment_type)
    );
  }
  return person.contracts.some(
    (contract) => list.includes(contract.employment_type) && contract.start_date <= timeRange.endDate && (!contract.end_date || contract.end_date >= timeRange.startDate)
  );
};

// src/engines/local/filter-fns/person-id.ts
var personId2 = ({ list }, { person }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return list.includes(person.id);
};

// src/engines/local/filter-fns/person-is-active.ts
var personIsActive2 = ({ value }, { person }) => {
  if (!person) {
    return false;
  }
  return person.active === value;
};

// src/engines/local/filter-fns/person-is-favourite.ts
var personIsFavourite2 = ({ value }, { person }) => {
  if (!person) {
    return false;
  }
  return person.is_favourite === value;
};

// src/engines/local/filter-fns/person-is-placeholder.ts
var personIsPlaceholder2 = ({ value }, { person }) => {
  if (!person) {
    return false;
  }
  return person.is_placeholder === value;
};

// src/engines/local/filter-fns/person-job-title-name.ts
var personJobTitleName2 = ({
  query,
  searchType
}) => {
  const searchValues = query.trim().toLowerCase().split("|").map((v) => remove_accents_regexp_default(v.trim())).filter((v) => v);
  if (searchValues.length === 0) {
    return () => true;
  }
  if (searchType === "exact") {
    return ({ person }) => {
      if (!person) {
        return false;
      }
      const jobTitle = person?.current_contract[0]?.job_title;
      if (!jobTitle) {
        return false;
      }
      const value = remove_accents_regexp_default(jobTitle.toLowerCase());
      return searchValues.some((searchValue) => {
        return value === searchValue;
      });
    };
  }
  if (searchType === "includes") {
    const regexpList = searchValues.map((searchValue) => {
      return new RegExp(`(?:^|\\W)${escape_string_regexp_default(searchValue)}`, "i");
    });
    return ({ person }) => {
      if (!person) {
        return false;
      }
      const jobTitle = person?.current_contract[0]?.job_title;
      if (!jobTitle) {
        return false;
      }
      const value = remove_accents_regexp_default(jobTitle.toLowerCase());
      return regexpList.some((regexp) => {
        return regexp.test(value);
      });
    };
  }
  throw new Error(`Unsupported searchType: ${searchType}`);
};

// src/engines/local/filter-fns/person-manager-id.ts
var personManagerId2 = ({ list }, { person }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return person.managers.some((manager) => list.includes(manager.user_id));
};

// src/engines/local/filter-fns/person-membership.ts
var personMembership2 = ({ list, hasAnyProjects = false }, { person }, { showScheduledWithinTimeFrame }) => {
  if (!person) {
    return false;
  }
  if (hasAnyProjects) {
    return person.projects.length > 0;
  }
  if (list.length === 0) {
    return true;
  }
  return person.projects.some((project) => {
    return list.includes(project.id) && (showScheduledWithinTimeFrame ? project.has_assignments_in_time_frame : true);
  });
};

// src/engines/local/filter-fns/person-name.ts
var personName2 = ({ query }) => {
  const regex = new RegExp(
    `(?:^|\\W)${remove_accents_regexp_default(escape_string_regexp_default(query))}`,
    "i"
  );
  return ({ person }) => {
    if (!person) {
      return false;
    }
    return regex.test(
      `${remove_accents_regexp_default(person.first_name)} ${remove_accents_regexp_default(
        person.last_name
      )}`
    );
  };
};

// src/engines/local/filter-fns/person-placeholder-status.ts
var personPlaceholderStatus2 = ({ list }, { person }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  if (!person.is_placeholder) {
    return false;
  }
  return list.includes(person?.person_requests?.[0]?.status || "");
};

// src/engines/local/filter-fns/person-project-client-id.ts
var personProjectClientId2 = ({ list }, { person }, { showScheduledWithinTimeFrame }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return person.projects.some((project) => {
    if (!project.client) {
      return false;
    }
    return list.includes(project.client.id) && (showScheduledWithinTimeFrame ? project.has_assignments_in_time_frame : true);
  });
};

// src/engines/local/filter-fns/person-project-client-name.ts
var personProjectClientName2 = ({ query }) => {
  const regexp = new RegExp(
    `(?:^|\\W)${remove_accents_regexp_default(escape_string_regexp_default(query))}`,
    "i"
  );
  return ({ person }) => {
    if (!person) {
      return false;
    }
    return person.projects.some(
      (project) => regexp.test(remove_accents_regexp_default(project.client.name))
    );
  };
};

// src/engines/local/filter-fns/person-project-custom-checkbox.ts
var personProjectCustomCheckbox2 = ({ query, typeId }, { showScheduledWithinTimeFrame } = {}) => {
  return ({ person }) => {
    if (!person) {
      return false;
    }
    return person.projects.some((project) => {
      return project.custom_checkbox_values.filter(
        (v) => v.custom_checkbox_type_id === typeId && (showScheduledWithinTimeFrame ? project.has_assignments_in_time_frame : true)
      ).some((c) => c.value === query);
    });
  };
};

// src/engines/local/filter-fns/person-project-custom-date-value.ts
var personProjectCustomDateValue2 = (datePayload) => {
  return ({ person }) => {
    if (!person) {
      return false;
    }
    if (datePayload.type === "exact") {
      if (!datePayload.exact) {
        return true;
      }
      const exact = new Date(datePayload.exact);
      return person.projects.some(
        (p) => (p.custom_date_values ?? []).some((c) => {
          const value = new Date(c.value);
          return value.toDateString() === exact.toDateString();
        })
      );
    } else if (datePayload.type === "range") {
      if (!datePayload.start || !datePayload.end) {
        return true;
      }
      const start = new Date(datePayload.start);
      const end = new Date(datePayload.end);
      return person.projects.some(
        (p) => (p.custom_date_values ?? []).some((c) => {
          const value = new Date(c.value);
          return value >= start && value <= end;
        })
      );
    }
    return false;
  };
};

// src/engines/local/filter-fns/person-project-custom-date.ts
var personProjectCustomDate2 = ({ datePayload, typeId }, { showScheduledWithinTimeFrame } = {}) => {
  return ({ person }) => {
    if (!person) {
      return false;
    }
    if (datePayload.type === "exact") {
      if (!datePayload.exact) {
        return true;
      }
      const exact = new Date(datePayload.exact);
      return person.projects.some((p) => {
        return (p.custom_date_values ?? []).filter(
          (v) => v.custom_date_type_id === typeId && (showScheduledWithinTimeFrame ? p.has_assignments_in_time_frame : true)
        ).find((c) => {
          const value = new Date(c.value);
          return value.toDateString() === exact.toDateString();
        });
      });
    } else if (datePayload.type === "range") {
      if (!datePayload.start || !datePayload.end) {
        return true;
      }
      const start = new Date(datePayload.start);
      const end = new Date(datePayload.end);
      return person.projects.some((p) => {
        return (p.custom_date_values ?? []).filter(
          (v) => v.custom_date_type_id === typeId && (showScheduledWithinTimeFrame ? p.has_assignments_in_time_frame : true)
        ).find((c) => {
          const value = new Date(c.value);
          return value >= start && value <= end;
        });
      });
    }
    return false;
  };
};

// src/engines/local/filter-fns/person-project-custom-select.ts
var personProjectCustomSelect2 = ({ list }, { person }, { showScheduledWithinTimeFrame }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return person.projects.some(
    (p) => p.custom_select_values.some(
      (v) => list.includes(v.custom_select_option_id) && (showScheduledWithinTimeFrame ? p.has_assignments_in_time_frame : true)
    )
  );
};

// src/engines/local/filter-fns/person-project-custom-text-value.ts
var personProjectCustomTextValue2 = ({ query }) => {
  const words = escape_string_regexp_default(query).split(" ");
  const regexp = new RegExp(`(?:^|\\W)(${words.join("|")})`, "i");
  return ({ person }) => {
    if (!person) {
      return false;
    }
    return person.projects.some(
      (p) => (p.custom_text_values ?? []).some((c) => {
        return regexp.test(c.value);
      })
    );
  };
};

// src/engines/local/filter-fns/person-project-custom-text.ts
var personProjectCustomText2 = ({ typeId, query, searchType }, { showScheduledWithinTimeFrame } = {}) => {
  return ({ person }) => {
    if (!person) {
      return false;
    }
    const searchValues = query.trim().toLowerCase().split("|").map((v) => remove_accents_regexp_default(v.trim())).filter((v) => v);
    if (searchValues.length === 0) {
      return true;
    }
    return searchValues.some((searchValue) => {
      const regexp = new RegExp(
        `(?:^|\\W)${escape_string_regexp_default(searchValue)}`,
        "i"
      );
      return person.projects.some((project) => {
        return (project.custom_text_values ?? []).filter(
          (v) => v.custom_text_type_id === typeId && (showScheduledWithinTimeFrame ? project.has_assignments_in_time_frame : true)
        ).some((c) => {
          const value = remove_accents_regexp_default(c.value.toLowerCase());
          if (searchType === "exact") {
            return value === searchValue;
          }
          return regexp.test(value);
        });
      });
    });
  };
};

// src/engines/local/filter-fns/person-project-id.ts
var personProjectId2 = ({ list }, { person }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return person.projects.some((project) => {
    return list.includes(project.id) && project.has_assignments;
  });
};

// src/engines/local/filter-fns/person-project-is-confirmed.ts
var personProjectIsConfirmed2 = ({ value }, { person }) => {
  if (!person) {
    return false;
  }
  return person.projects.some((project) => project.confirmed === value);
};

// src/engines/local/filter-fns/person-project-manager-id.ts
var personProjectManagerId2 = ({ list }, { person }, { showScheduledWithinTimeFrame }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return person.projects.some(
    (project) => project.managers.some((manager) => list.includes(manager.user_id)) && (showScheduledWithinTimeFrame ? project.has_assignments_in_time_frame : true)
  );
};

// src/engines/local/filter-fns/person-project-name.ts
var personProjectName2 = ({
  query
}) => {
  const regexp = new RegExp(remove_accents_regexp_default(escape_string_regexp_default(query)), "i");
  return ({ person }) => {
    if (!person) {
      return false;
    }
    return person.projects.some(
      (project) => regexp.test(remove_accents_regexp_default(project.name))
    );
  };
};

// src/engines/local/filter-fns/person-project-role-id.ts
var personProjectRoleId2 = ({ list }, { person }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return person.projects.some((project) => {
    return project.members.some((member) => {
      if (member.person_id !== person.id) {
        return false;
      }
      return member.role_id ? list.includes(member.role_id) : false;
    });
  });
};

// src/engines/local/filter-fns/person-project-status.ts
var personProjectStatus2 = ({ list }, { person }, { showScheduledWithinTimeFrame }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return person.projects.some((project) => {
    const status = project.confirmed ? "confirmed" : "tentative";
    return list.includes(status) && (showScheduledWithinTimeFrame ? project.has_assignments_in_time_frame : true);
  });
};

// src/engines/local/filter-fns/person-project-tag-id.ts
var personProjectTagId2 = ({ list }, { showScheduledWithinTimeFrame } = {}) => {
  const listLC = list.map((tag) => tag.toLowerCase());
  return ({ person }) => {
    if (!person) {
      return false;
    }
    if (list.length === 0) {
      return true;
    }
    return person.projects.some((project) => {
      if (!project.tags) {
        return false;
      }
      return project.tags.some((tag) => {
        return listLC.includes(tag.toLowerCase()) && (showScheduledWithinTimeFrame ? project.has_assignments_in_time_frame : true);
      });
    });
  };
};

// src/engines/local/filter-fns/person-project-team-id.ts
var personProjectTeamId2 = ({ list }, { person }, { showScheduledWithinTimeFrame }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return person.projects.some((project) => {
    if (project.team == null) {
      return false;
    }
    return list.includes(project.team.id) && (showScheduledWithinTimeFrame ? project.has_assignments_in_time_frame : true);
  });
};

// src/engines/local/filter-fns/person-project-template-id.ts
var personProjectTemplateId2 = ({ list }, { person }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return person.projects.filter((project) => project.is_template).some((project) => {
    return list.includes(project.id);
  });
};

// src/engines/local/filter-fns/person-project-workstream-id.ts
var personProjectWorkstreamId2 = ({ list }, { person }, { showScheduledWithinTimeFrame }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return person.projects.some((project) => {
    return project.members.some((member) => {
      if (member.person_id !== person.id) {
        return false;
      }
      return member.workstream_id ? list.includes(member.workstream_id) && (showScheduledWithinTimeFrame ? project.has_assignments_in_time_frame : true) : false;
    });
  });
};

// src/engines/local/filter-fns/person-role-id.ts
var personRoleId2 = ({ list }, { person }, { timeRange }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  if (!person.contracts?.length) {
    return false;
  }
  if (!timeRange) {
    return person.contracts.some((contract) => list.includes(contract.role.id));
  }
  return person.contracts.some(
    (contract) => list.includes(contract.role.id) && contract.start_date <= timeRange.endDate && (!contract.end_date || contract.end_date >= timeRange.startDate)
  );
};

// src/engines/local/filter-fns/person-role-name.ts
var personRoleName2 = ({ query }) => {
  const safeQuery = remove_accents_regexp_default(escape_string_regexp_default(query));
  const isPlural = safeQuery.length > 3 && safeQuery.endsWith("s");
  const regexp = new RegExp(`${safeQuery}${isPlural ? "?" : ""}`, "i");
  return ({ person }) => {
    if (!person || !person.current_contract[0]) {
      return false;
    }
    return regexp.test(remove_accents_regexp_default(person.current_contract[0].role.name));
  };
};

// src/engines/local/filter-fns/person-skill-id.ts
var ALL_SKILL_LEVELS = [null, 1, 2, 3, 4];
var personSkillId2 = ({ list }, { person }) => {
  if (!person || !person.competencies) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  const skillLevelList = migrateLegacySkillIdList(list);
  const { matchSkillIdAndLevel, matchSkillId } = skillLevelList.reduce(
    (acc, item) => {
      const matchAnySkillLevel = ALL_SKILL_LEVELS.every(
        (level) => item.level.includes(level)
      );
      if (matchAnySkillLevel) {
        acc.matchSkillId.add(item.skillId);
      } else {
        const skillLevelSet = acc.matchSkillIdAndLevel.get(item.skillId) ?? /* @__PURE__ */ new Set();
        item.level.forEach((level) => skillLevelSet.add(level));
        acc.matchSkillIdAndLevel.set(item.skillId, skillLevelSet);
      }
      return acc;
    },
    {
      matchSkillIdAndLevel: /* @__PURE__ */ new Map(),
      matchSkillId: /* @__PURE__ */ new Set()
    }
  );
  return person.competencies.some((competency) => {
    if (matchSkillId.has(competency.skill.id)) {
      return true;
    }
    if (matchSkillIdAndLevel.has(competency.skill.id)) {
      if (matchSkillIdAndLevel.get(competency.skill.id)?.has(competency.level)) {
        return true;
      }
    }
    return false;
  });
};

// src/engines/local/filter-fns/person-skill-name.ts
var personSkillName2 = ({ query }) => {
  const regexp = new RegExp(
    `(?:^|\\W)${remove_accents_regexp_default(escape_string_regexp_default(query))}`,
    "i"
  );
  return ({ person }) => {
    if (!person || !person.competencies) {
      return false;
    }
    return person.competencies.some((c) => {
      return regexp.test(remove_accents_regexp_default(c.skill.name));
    });
  };
};

// src/engines/local/filter-fns/person-state.ts
var personState2 = ({ list }, { person }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  if (person.active && list.includes("active")) {
    return true;
  }
  if (!person.active && list.includes("archived")) {
    return true;
  }
  return false;
};

// src/engines/local/filter-fns/person-tag-id.ts
var personTagId2 = ({ list }) => {
  const listLC = list.map((tag) => tag.toLowerCase());
  return ({ person }) => {
    if (!person || !person.tags) {
      return false;
    }
    if (list.length === 0) {
      return true;
    }
    return person.tags.some((tag) => listLC.includes(tag.toLowerCase()));
  };
};

// src/engines/local/filter-fns/person-tag-name.ts
var personTagName2 = ({ query }) => {
  const regexp = new RegExp(
    `(?:^|\\W)${remove_accents_regexp_default(escape_string_regexp_default(query))}`,
    "i"
  );
  return ({ person }) => {
    if (!person || !person.tags) {
      return false;
    }
    return person.tags.some((tag) => {
      return regexp.test(remove_accents_regexp_default(tag));
    });
  };
};

// src/engines/local/filter-fns/person-team-id.ts
var personTeamId2 = ({ list }, { person }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  if (person.team == null) {
    return false;
  }
  return list.includes(person.team.id);
};

// src/engines/local/filter-fns/person-team-name.ts
var personTeamName2 = ({ query }) => {
  const regexp = new RegExp(remove_accents_regexp_default(escape_string_regexp_default(query)), "i");
  return ({ person }) => {
    if (!person) {
      return false;
    }
    if (person.team == null) {
      return false;
    }
    return regexp.test(remove_accents_regexp_default(person.team.name));
  };
};

// src/engines/local/filter-fns/person-type.ts
var personType2 = ({ list }, { person }) => {
  if (!person) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  if (list.includes("person") && !person.is_placeholder) {
    return true;
  }
  if (list.includes("placeholder") && person.is_placeholder) {
    return true;
  }
  return false;
};

// src/engines/local/filter-fns/person-wild-search.ts
var personWildSearch2 = (options) => {
  if (options.query.length === 0) {
    return () => true;
  }
  const matchPersonProjectClientName = personProjectClientName2(options);
  const matchPersonName = personName2(options);
  const matchPersonProjectName = personProjectName2(options);
  const matchPersonRoleName = personRoleName2(options);
  const matchPersonSkillName = personSkillName2(options);
  const matchPersonTagName = personTagName2(options);
  const matchPersonTeamName = personTeamName2(options);
  const matchPersonCustomTextValue = personCustomTextValue2(options);
  return (context) => matchPersonProjectClientName(context) || matchPersonName(context) || matchPersonProjectName(context) || matchPersonRoleName(context) || matchPersonSkillName(context) || matchPersonTagName(context) || matchPersonTeamName(context) || matchPersonCustomTextValue(context);
};

// src/engines/local/filter-fns/project-client-id.ts
var projectClientId2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (project.client == null) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return list.includes(project.client.id);
};

// src/engines/local/filter-fns/project-client-name.ts
var projectClientName2 = ({
  query
}) => {
  const regexp = new RegExp(
    `(?:^|\\W)${remove_accents_regexp_default(escape_string_regexp_default(query))}`,
    "i"
  );
  return ({ project }) => {
    if (!project) {
      return false;
    }
    return regexp.test(remove_accents_regexp_default(project.client.name));
  };
};

// src/engines/local/filter-fns/project-custom-checkbox.ts
var projectCustomCheckbox2 = ({
  typeId,
  query
}) => {
  return ({ project }) => {
    if (!project || !project.custom_checkbox_values) {
      return false;
    }
    return project.custom_checkbox_values.filter((v) => v.custom_checkbox_type_id === typeId).some((c) => c.value === query);
  };
};

// src/engines/local/filter-fns/project-custom-date-value.ts
var projectCustomDateValue2 = (datePayload) => {
  return ({ project }) => {
    if (!project || !project.custom_date_values) {
      return false;
    }
    if (datePayload.type === "exact") {
      if (!datePayload.exact) {
        return true;
      }
      const exact = new Date(datePayload.exact);
      return project.custom_date_values.some((c) => {
        const value = new Date(c.value);
        return value.toDateString() === exact.toDateString();
      });
    } else if (datePayload.type === "range") {
      if (!datePayload.start || !datePayload.end) {
        return true;
      }
      const start = new Date(datePayload.start);
      const end = new Date(datePayload.end);
      return project.custom_date_values.some((c) => {
        const value = new Date(c.value);
        return value >= start && value <= end;
      });
    }
    return false;
  };
};

// src/engines/local/filter-fns/project-custom-date.ts
var projectCustomDate2 = ({
  typeId,
  datePayload
}) => {
  return ({ project }) => {
    if (!project || !project.custom_date_values) {
      return false;
    }
    const customDateValues = project.custom_date_values.filter(
      (v) => v.custom_date_type_id === typeId
    );
    if (datePayload.type === "exact") {
      if (!datePayload.exact) {
        return true;
      }
      const exact = new Date(datePayload.exact);
      return Boolean(
        project.custom_date_values.filter((v) => v.custom_date_type_id === typeId).find((c) => {
          const value = new Date(c.value);
          return value.toDateString() === exact.toDateString();
        })
      );
    } else if (datePayload.type === "range") {
      if (!datePayload.start || !datePayload.end) {
        return true;
      }
      const start = new Date(datePayload.start);
      const end = new Date(datePayload.end);
      return Boolean(
        customDateValues.find((c) => {
          const value = new Date(c.value);
          return value >= start && value <= end;
        })
      );
    }
    return false;
  };
};

// src/engines/local/filter-fns/project-custom-select.ts
var projectCustomSelect2 = ({ list }, { project }) => {
  if (!project || !project.custom_select_values) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return project.custom_select_values.some(
    (v) => list.includes(v.custom_select_option_id)
  );
};

// src/engines/local/filter-fns/project-custom-text-value.ts
var projectCustomTextValue2 = ({
  query
}) => {
  const words = remove_accents_regexp_default(escape_string_regexp_default(query)).split(" ");
  const regexp = new RegExp(`(?:^|\\W)(${words.join("|")})`, "i");
  return ({ project }) => {
    if (!project || !project.custom_text_values) {
      return false;
    }
    return project.custom_text_values.some((c) => {
      return regexp.test(remove_accents_regexp_default(c.value));
    });
  };
};

// src/engines/local/filter-fns/project-custom-text.ts
var projectCustomText2 = ({
  typeId,
  query,
  searchType
}) => {
  return ({ project }) => {
    if (!project || !project.custom_text_values) {
      return false;
    }
    const searchValues = query.trim().toLowerCase().split("|").map((v) => remove_accents_regexp_default(v.trim())).filter((v) => v);
    if (searchValues.length === 0) {
      return true;
    }
    return searchValues.some((searchValue) => {
      const regexp = new RegExp(
        `(?:^|\\W)${escape_string_regexp_default(searchValue)}`,
        "i"
      );
      return (project.custom_text_values ?? []).filter((v) => v.custom_text_type_id === typeId).some((c) => {
        const value = remove_accents_regexp_default(c.value.toLowerCase());
        if (searchType === "exact") {
          return value === searchValue;
        }
        return regexp.test(value);
      });
    });
  };
};

// src/engines/local/filter-fns/project-id.ts
var projectId2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return list.includes(project.id);
};

// src/engines/local/filter-fns/project-is-active.ts
var projectIsActive2 = ({ value }, { project }) => {
  if (!project) {
    return false;
  }
  return project.active === value;
};

// src/engines/local/filter-fns/project-is-confirmed.ts
var projectIsConfirmed2 = ({ value }, { project }) => {
  if (!project) {
    return false;
  }
  return project.confirmed === value;
};

// src/engines/local/filter-fns/project-is-favourite.ts
var projectIsFavourite2 = ({ value }, { project }) => {
  if (!project) {
    return false;
  }
  return project.is_favourite === value;
};

// src/engines/local/filter-fns/project-is-template.ts
var projectIsTemplate2 = ({ value }, { project }) => {
  if (!project) {
    return false;
  }
  return project.is_template === value;
};

// src/engines/local/filter-fns/project-manager-id.ts
var projectManagerId2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return project.managers.some((manager) => list.includes(manager.user_id));
};

// src/engines/local/filter-fns/project-name.ts
var projectName2 = ({ query }) => {
  const regexp = new RegExp(remove_accents_regexp_default(escape_string_regexp_default(query)), "i");
  return ({ project }) => {
    if (!project) {
      return false;
    }
    return regexp.test(remove_accents_regexp_default(project.name));
  };
};

// src/engines/local/filter-fns/project-person-custom-checkbox.ts
var projectPersonCustomCheckbox2 = ({ query, typeId }) => {
  return ({ project }) => {
    if (!project) {
      return false;
    }
    return project.people.some((person) => {
      return person.custom_checkbox_values.filter((v) => v.custom_checkbox_type_id === typeId).some((c) => c.value === query);
    });
  };
};

// src/engines/local/filter-fns/project-person-custom-date-value.ts
var projectPersonCustomDateValue2 = (datePayload) => {
  return ({ project }) => {
    if (!project) {
      return false;
    }
    if (datePayload.type === "exact") {
      if (!datePayload.exact) {
        return true;
      }
      const exact = new Date(datePayload.exact);
      return project.people.some(
        (p) => (p.custom_date_values ?? []).some((c) => {
          const value = new Date(c.value);
          return value.toDateString() === exact.toDateString();
        })
      );
    } else if (datePayload.type === "range") {
      if (!datePayload.start || !datePayload.end) {
        return true;
      }
      const start = new Date(datePayload.start);
      const end = new Date(datePayload.end);
      return project.people.some(
        (p) => (p.custom_date_values ?? []).some((c) => {
          const value = new Date(c.value);
          return value >= start && value <= end;
        })
      );
    }
    return false;
  };
};

// src/engines/local/filter-fns/project-person-custom-date.ts
var projectPersonCustomDate2 = ({ typeId, datePayload }) => {
  return ({ project }) => {
    if (!project) {
      return false;
    }
    if (datePayload.type === "exact") {
      if (!datePayload.exact) {
        return true;
      }
      const exact = new Date(datePayload.exact);
      return project.people.some((p) => {
        return (p.custom_date_values ?? []).filter((v) => v.custom_date_type_id === typeId).find((c) => {
          const value = new Date(c.value);
          return value.toDateString() === exact.toDateString();
        });
      });
    } else if (datePayload.type === "range") {
      if (!datePayload.start || !datePayload.end) {
        return true;
      }
      const start = new Date(datePayload.start);
      const end = new Date(datePayload.end);
      return project.people.some((p) => {
        return (p.custom_date_values ?? []).filter((v) => v.custom_date_type_id === typeId).find((c) => {
          const value = new Date(c.value);
          return value >= start && value <= end;
        });
      });
    }
    return false;
  };
};

// src/engines/local/filter-fns/project-person-custom-select.ts
var projectPersonCustomSelect2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return project.people.some(
    (p) => p.custom_select_values.some(
      (v) => list.includes(v.custom_select_option_id)
    )
  );
};

// src/engines/local/filter-fns/project-person-custom-text-value.ts
var projectPersonCustomTextValue2 = ({ query }) => {
  const words = escape_string_regexp_default(query).split(" ");
  const regexp = new RegExp(`(?:^|\\W)(${words.join("|")})`, "i");
  return ({ project }) => {
    if (!project) {
      return false;
    }
    return project.people.some(
      (p) => (p.custom_text_values ?? []).some((c) => {
        return regexp.test(c.value);
      })
    );
  };
};

// src/engines/local/filter-fns/project-person-custom-text.ts
var projectPersonCustomText2 = ({ typeId, query, searchType }) => {
  return ({ project }) => {
    if (!project) {
      return false;
    }
    const searchValues = query.trim().toLowerCase().split("|").map((v) => remove_accents_regexp_default(v.trim())).filter((v) => v);
    if (searchValues.length === 0) {
      return true;
    }
    return searchValues.some((searchValue) => {
      const regexp = new RegExp(
        `(?:^|\\W)${escape_string_regexp_default(searchValue)}`,
        "i"
      );
      return project.people.some((p) => {
        return (p.custom_text_values ?? []).filter((v) => v.custom_text_type_id === typeId).some((c) => {
          const value = remove_accents_regexp_default(c.value.toLowerCase());
          if (searchType === "exact") {
            return value === searchValue;
          }
          return regexp.test(value);
        });
      });
    });
  };
};

// src/engines/local/filter-fns/project-person-email.ts
var projectPersonEmail2 = ({
  query
}) => {
  const regexp = new RegExp(`^${escape_string_regexp_default(query)}`, "i");
  return ({ project }) => {
    if (!project) {
      return false;
    }
    return project.people.some((person) => {
      if (typeof person.email !== "string") {
        return false;
      }
      return regexp.test(person.email);
    });
  };
};

// src/engines/local/filter-fns/project-person-id.ts
var projectPersonId2 = ({ list, hasAnyPeople = false }, { project }) => {
  if (!project) {
    return false;
  }
  if (hasAnyPeople) {
    return project.people.length > 0;
  }
  if (list.length === 0) {
    return true;
  }
  return project.people.some((person) => {
    return list.includes(person.id);
  });
};

// src/engines/local/filter-fns/project-person-job-title-name.ts
var projectPersonJobTitleName2 = ({ query, searchType }) => {
  const searchValues = query.trim().toLowerCase().split("|").map((v) => remove_accents_regexp_default(v.trim())).filter((v) => v);
  if (searchValues.length === 0) {
    return () => true;
  }
  if (searchType === "exact") {
    return ({ project }) => {
      if (!project) {
        return false;
      }
      return searchValues.some((searchValue) => {
        return project.people.some((p) => {
          const jobTitle = p.current_contract?.[0]?.job_title;
          if (!jobTitle) {
            return false;
          }
          const value = remove_accents_regexp_default(jobTitle.toLowerCase());
          return value === searchValue;
        });
      });
    };
  }
  if (searchType === "includes") {
    const regexList = searchValues.map((searchValue) => {
      return new RegExp(`(?:^|\\W)${escape_string_regexp_default(searchValue)}`, "i");
    });
    return ({ project }) => {
      if (!project) {
        return false;
      }
      return regexList.some((regexp) => {
        return project.people.some((p) => {
          const jobTitle = p.current_contract?.[0]?.job_title;
          if (!jobTitle) {
            return false;
          }
          const value = remove_accents_regexp_default(jobTitle.toLowerCase());
          return regexp.test(value);
        });
      });
    };
  }
  throw new Error(`Unsupported search type: ${searchType}`);
};

// src/engines/local/filter-fns/project-person-manager-id.ts
var projectPersonManagerId2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return project.people.some(
    (person) => person.managers.some((manager) => list.includes(manager.user_id))
  );
};

// src/engines/local/filter-fns/project-person-name.ts
var projectPersonName2 = ({
  query
}) => {
  const regexp = new RegExp(
    `(?:^|\\W)${remove_accents_regexp_default(escape_string_regexp_default(query))}`,
    "i"
  );
  return ({ project }) => {
    if (!project) {
      return false;
    }
    return project.people.some((person) => {
      return regexp.test(
        `${remove_accents_regexp_default(person.first_name)} ${remove_accents_regexp_default(
          person.last_name
        )}`
      );
    });
  };
};

// src/engines/local/filter-fns/project-person-placeholder-status.ts
var projectPersonPlaceholderStatus2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return project.people.some((person) => {
    if (!person.is_placeholder) {
      return false;
    }
    return list.includes(person?.person_requests?.[0]?.status || "");
  });
};

// src/engines/local/filter-fns/project-person-role-id.ts
var projectPersonRoleId2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return project.members.some((member) => {
    return list.includes(member.role_id);
  });
};

// src/engines/local/filter-fns/project-person-skill-id.ts
var ALL_SKILL_LEVELS2 = [null, 1, 2, 3, 4];
var projectPersonSkillId2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (!list.length) {
    return true;
  }
  const skillLevelList = migrateLegacySkillIdList(list);
  const { matchSkillIdAndLevel, matchSkillId } = skillLevelList.reduce(
    (acc, item) => {
      const matchAnySkillLevel = ALL_SKILL_LEVELS2.every(
        (level) => item.level.includes(level)
      );
      if (matchAnySkillLevel) {
        acc.matchSkillId.add(item.skillId);
      } else {
        const skillLevelSet = acc.matchSkillIdAndLevel.get(item.skillId) ?? /* @__PURE__ */ new Set();
        item.level.forEach((level) => skillLevelSet.add(level));
        acc.matchSkillIdAndLevel.set(item.skillId, skillLevelSet);
      }
      return acc;
    },
    {
      matchSkillIdAndLevel: /* @__PURE__ */ new Map(),
      matchSkillId: /* @__PURE__ */ new Set()
    }
  );
  return project.people.some((person) => {
    if (!person.competencies) {
      return false;
    }
    return person.competencies.some((competency) => {
      if (matchSkillId.has(competency.skill.id)) {
        return true;
      }
      if (matchSkillIdAndLevel.has(competency.skill.id)) {
        if (matchSkillIdAndLevel.get(competency.skill.id)?.has(competency.level)) {
          return true;
        }
      }
      return false;
    });
  });
};

// src/engines/local/filter-fns/project-person-tag-id.ts
var projectPersonTagId2 = ({
  list
}) => {
  const listLC = list.map((tag) => tag.toLowerCase());
  return ({ project }) => {
    if (!project) {
      return false;
    }
    if (list.length === 0) {
      return true;
    }
    return project.people.some((person) => {
      if (!person.tags) {
        return false;
      }
      return person.tags.some((tag) => listLC.includes(tag.toLowerCase()));
    });
  };
};

// src/engines/local/filter-fns/project-person-team-id.ts
var projectPersonTeamId2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return project.people.some((person) => {
    if (person.team == null) {
      return false;
    }
    return list.includes(person.team.id);
  });
};

// src/engines/local/filter-fns/project-pricing-model.ts
var projectPricingModel2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return list.includes(project.pricing_model);
};

// src/engines/local/filter-fns/project-state.ts
var projectState2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  if (project.active && list.includes("active")) {
    return true;
  }
  if (!project.active && list.includes("archived")) {
    return true;
  }
  return false;
};

// src/engines/local/filter-fns/project-status.ts
var projectStatus2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  const status = project.confirmed ? "confirmed" : "tentative";
  return list.includes(status);
};

// src/engines/local/filter-fns/project-tag-id.ts
var projectTagId2 = ({ list }) => {
  const listLC = list.map((tag) => tag.toLowerCase());
  return ({ project }) => {
    if (!project || !project.tags) {
      return false;
    }
    if (list.length === 0) {
      return true;
    }
    return project.tags.some((tag) => listLC.includes(tag.toLowerCase()));
  };
};

// src/engines/local/filter-fns/project-tag-name.ts
var projectTagName2 = ({ query }) => {
  const words = remove_accents_regexp_default(escape_string_regexp_default(query)).split(" ");
  const regexp = new RegExp(`(?:^|\\W)(${words.join("|")})`, "i");
  return ({ project }) => {
    if (!project || !project.tags) {
      return false;
    }
    return project.tags.some((tag) => {
      return regexp.test(remove_accents_regexp_default(tag));
    });
  };
};

// src/engines/local/filter-fns/project-team-id.ts
var projectTeamId2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  if (project.team == null) {
    return false;
  }
  return list.includes(project.team.id);
};

// src/engines/local/filter-fns/project-team-name.ts
var projectTeamName2 = ({ query }) => {
  const regexp = new RegExp(remove_accents_regexp_default(escape_string_regexp_default(query)), "i");
  return ({ project }) => {
    if (!project) {
      return false;
    }
    if (project.team == null) {
      return false;
    }
    return regexp.test(
      remove_accents_regexp_default(remove_accents_regexp_default(project.team.name))
    );
  };
};

// src/engines/local/filter-fns/project-template-id.ts
var projectTemplateId2 = ({ list }, { project }) => {
  if (list.length === 0) {
    return true;
  }
  if (!project || !project.is_template) {
    return false;
  }
  return list.includes(project.id);
};

// src/engines/local/filter-fns/project-wild-search.ts
var projectWildSearch2 = (options) => {
  if (options.query.length === 0) {
    return () => true;
  }
  const matchProjectClientName = projectClientName2(options);
  const matchProjectName = projectName2(options);
  const matchProjectPersonName = projectPersonName2(options);
  const matchProjectTagName = projectTagName2(options);
  const matchProjectTeamName = projectTeamName2(options);
  const matchProjectCustomTextValue = projectCustomTextValue2(options);
  return (context) => matchProjectClientName(context) || matchProjectName(context) || matchProjectPersonName(context) || matchProjectTagName(context) || matchProjectTeamName(context) || matchProjectCustomTextValue(context);
};

// src/engines/local/filter-fns/project-workstream-id.ts
var projectWorkstreamId2 = ({ list }, { project }) => {
  if (!project) {
    return false;
  }
  if (list.length === 0) {
    return true;
  }
  return project.project_workstreams.some(({ workstream }) => {
    return list.includes(workstream.id);
  });
};

// src/engines/local/filter-fns/index.ts
var filterRegistry = /* @__PURE__ */ new Map();
var load = (type, filterFn) => {
  if (filterRegistry.has(type)) {
    throw new Error(`Duplicate filter handler found for type: ${type}`);
  }
  filterRegistry.set(type, filterFn);
};
load("person_custom_select", personCustomSelect2);
load("person_custom_text", personCustomText2);
load("person_custom_text_value", personCustomTextValue2);
load("person_custom_date", personCustomDate2);
load("person_custom_date_value", personCustomDateValue2);
load("person_email", personEmail2);
load("person_employment_type", personEmploymentType2);
load("person_type", personType2);
load("person_id", personId2);
load("person_is_active", personIsActive2);
load("person_is_favourite", personIsFavourite2);
load("person_is_placeholder", personIsPlaceholder2);
load("person_job_title_name", personJobTitleName2);
load("person_name", personName2);
load("person_project_id", personProjectId2);
load("person_membership", personMembership2);
load("person_project_template_id", personProjectTemplateId2);
load("person_project_client_name", personProjectClientName2);
load("person_project_is_confirmed", personProjectIsConfirmed2);
load("person_project_name", personProjectName2);
load("person_project_status", personProjectStatus2);
load("person_project_custom_select", personProjectCustomSelect2);
load("person_project_custom_text", personProjectCustomText2);
load("person_project_custom_text_value", personProjectCustomTextValue2);
load("person_project_custom_date", personProjectCustomDate2);
load("person_project_custom_date_value", personProjectCustomDateValue2);
load("project_custom_date", projectCustomDate2);
load("project_custom_date_value", projectCustomDateValue2);
load("project_person_custom_select", projectPersonCustomSelect2);
load("project_person_custom_text", projectPersonCustomText2);
load("project_person_custom_text_value", projectPersonCustomTextValue2);
load("project_person_custom_date", projectPersonCustomDate2);
load("project_person_custom_date_value", projectPersonCustomDateValue2);
load("project_person_job_title_name", projectPersonJobTitleName2);
load("person_role_id", personRoleId2);
load("person_role_name", personRoleName2);
load("person_skill_id", personSkillId2);
load("person_skill_name", personSkillName2);
load("person_state", personState2);
load("person_tag_id", personTagId2);
load("person_tag_name", personTagName2);
load("person_team_id", personTeamId2);
load("person_team_name", personTeamName2);
load("person_wild_search", personWildSearch2);
load("person_placeholder_status", personPlaceholderStatus2);
load("project_client_id", projectClientId2);
load("project_client_name", projectClientName2);
load("project_custom_select", projectCustomSelect2);
load("project_custom_text", projectCustomText2);
load("project_custom_text_value", projectCustomTextValue2);
load("project_id", projectId2);
load("project_is_active", projectIsActive2);
load("project_is_confirmed", projectIsConfirmed2);
load("project_is_favourite", projectIsFavourite2);
load("project_is_template", projectIsTemplate2);
load("project_name", projectName2);
load("project_person_email", projectPersonEmail2);
load("project_person_id", projectPersonId2);
load("project_person_name", projectPersonName2);
load("project_person_team_id", projectPersonTeamId2);
load("project_person_placeholder_status", projectPersonPlaceholderStatus2);
load("project_pricing_model", projectPricingModel2);
load("project_state", projectState2);
load("project_status", projectStatus2);
load("project_tag_id", projectTagId2);
load("project_tag_name", projectTagName2);
load("project_team_id", projectTeamId2);
load("project_team_name", projectTeamName2);
load("project_template_id", projectTemplateId2);
load("project_wild_search", projectWildSearch2);
load("person_project_tag_id", personProjectTagId2);
load("project_person_skill_id", projectPersonSkillId2);
load("project_person_tag_id", projectPersonTagId2);
load("person_project_client_id", personProjectClientId2);
load("person_project_team_id", personProjectTeamId2);
load("project_workstream_id", projectWorkstreamId2);
load("person_project_workstream_id", personProjectWorkstreamId2);
load("project_person_role_id", projectPersonRoleId2);
load("person_project_role_id", personProjectRoleId2);
load("person_custom_checkbox", personCustomCheckbox2);
load("project_custom_checkbox", projectCustomCheckbox2);
load("person_project_custom_checkbox", personProjectCustomCheckbox2);
load("project_person_custom_checkbox", projectPersonCustomCheckbox2);
load("project_manager_id", projectManagerId2);
load("person_manager_id", personManagerId2);
load("project_person_manager_id", projectPersonManagerId2);
load("person_project_manager_id", personProjectManagerId2);

// src/engines/local/compile-filter-set.ts
var toPartialFilterFn = (filter, globalFilterOpts) => {
  const filterFn = filterRegistry.get(filter.type);
  if (!filterFn) {
    console.debug(
      `Could not find filter fn for filter: ${filter.type}. Ensure it exists or try clearing local storage.`
    );
    return () => true;
  }
  if (filterFn.length === 1) {
    return filterFn(
      filter.options,
      globalFilterOpts
    );
  } else {
    return filterFn.bind(null, filter.options);
  }
};
var compileFilterList = (filterList2, globalFilterOpts) => {
  const { logic, items } = filterList2;
  const filterFnList = items.map((filter) => {
    if (isFilterList(filter)) {
      return compileFilterList(filter, globalFilterOpts);
    }
    return toPartialFilterFn(filter, globalFilterOpts);
  });
  switch (logic) {
    case "or":
      return (context) => {
        return filterFnList.some(
          (filterFn) => filterFn(context, globalFilterOpts)
        );
      };
    case "and":
      return (context) => {
        return filterFnList.every(
          (filterFn) => filterFn(context, globalFilterOpts)
        );
      };
    default:
      throw new Error(`Unsupported filter list logic: ${logic}`);
  }
};
var compileFilterSet = (filterSet, globalFilterOpts) => {
  const { filters } = filterSet;
  if (isFilterList(filters)) {
    return compileFilterList(filters, globalFilterOpts);
  }
  if (filters === null || filters === void 0) {
    return () => true;
  }
  return toPartialFilterFn(filters, globalFilterOpts);
};

// src/engines/local/create-filter-engine.ts
var filterList = (key, list, filterSet, globalFilterOpts = {}) => {
  const predicate = compileFilterSet(filterSet, globalFilterOpts);
  return list.filter((item) => {
    const context = { [key]: item };
    return predicate(context, globalFilterOpts);
  });
};
var filterProjectList = (projectList, filterSet, globalFilterOpts = {}) => {
  return filterList("project", projectList, filterSet, globalFilterOpts);
};
var filterPersonList = (personList, filterSet, globalFilterOpts = {}) => {
  return filterList("person", personList, filterSet, globalFilterOpts);
};

// src/utils/index.ts
var utils_exports = {};
__export(utils_exports, {
  isDatePayload: () => isDatePayload,
  printFilterSet: () => printFilterSet,
  removeAccentsRegex: () => remove_accents_regexp_default
});

// src/utils/log.ts
var formatOptions = (options) => Object.entries(options).map(([key, value]) => `${key}=${JSON.stringify(value)}`).join(" ");
var printFilter = (filter, prefix = "") => {
  console.log(
    `%c${prefix} %c${filter.type}%c %c${formatOptions(filter.options)}`,
    "color:#966B9D",
    "background:#F9DBBD;border-radius:10px;padding:0 5px;",
    "",
    "background:#FFF4EC;border-radius:10px;padding: 0 5px;"
  );
};
var recursivePrint = (filterList2, prefix = "") => {
  const { logic, items } = filterList2;
  console.log(
    `%c${prefix} %c${logic.toUpperCase()}`,
    "color:#966B9D",
    "color:#000000"
  );
  for (const [index, filter] of items.entries()) {
    const innerPrefix = `${prefix}  ${index + 1}.`;
    if (isFilterList(filter)) {
      recursivePrint(filter, innerPrefix);
    } else {
      printFilter(filter, innerPrefix);
    }
  }
};
var printFilterSet = (filterSet) => {
  console.group(`Filter: ${filterSet.name}`);
  if (isFilterList(filterSet.filters)) {
    recursivePrint(filterSet.filters);
  } else if (filterSet.filters) {
    printFilter(filterSet.filters);
  }
  console.groupEnd();
};
export {
  engines_exports as engines,
  filters_exports as filters,
  utils_exports as utils
};
//# sourceMappingURL=index.js.map